import { Logger, LoggerService } from "@Shared/logger";
import { PipelineContext, PipelineStep } from ".";
export class Pipeline {
    private Logger: Logger = LoggerService.createLogger("Pipeline");
    async execute(initialStep: PipelineStep, context: PipelineContext): Promise<void> {
        let currentStep: PipelineStep | null = initialStep;
        this.Logger.trace("Starting Pipeline...");
        let prevStep: PipelineStep | null = null;
        context.previousStep = null;
        while (currentStep) {
            //this.Logger.trace("Executing step:", currentStep.constructor.name);
            prevStep = currentStep;
            currentStep = await currentStep.execute(context);
            context.previousStep = prevStep;
            //this.Logger.trace("After Executing step:", currentStep?.constructor.name);
        }
        this.Logger.trace("Finishing Pipeline...");
    }
}